
import { api } from "@/utils/request";

export default {
  data() {
    return {
      isCarouselReady: false,
      isPopularVideoReady: false,
      isOtherReady: false,
      breadcrumb: [
        {
          text: "Home",
          to: "/",
        },
        {
          text: "Video",
          active: true,
        },
      ],
      featuredMediaData: [],
      loadingMediaData: true,
      videoData: [],
      popularVideoData: [],
      otherVideoData: [],
      search: "",
      pagination: {
        currentPage: 1,
        perPage: 9,
      },
      mediaType: 'VIDEO',
      title: 'Popular Video',
      redirectPage: 'video-slug',
      isEmptyPage: false,
    };
  },
  methods: {
    changePaging(page) {
      this.pagination = {
        ...this.pagination,
        currentPage: page,
      }

      this.fetchMediaList()
    },
    searchMedia(input) {
      this.fetchMediaList(input)
      this.search = input
    },
    onInitCarousel () {
      this.isCarouselReady = true;
    },
    async fetchFeaturedMediaList() {
      try {
        const medias = await api('featured-medias')
        if (medias && medias.result) {
          this.featuredMediaData = medias.result;
          this.loadingMediaData = false
        }
      } catch (e) {
        console.error(e)
      }
    },
    async fetchMediaList(search= '', category= '') {
      this.videoData = [];
      this.isEmptyPage = false;
      try {
        const reqParams = {
          page: this.pagination.currentPage || 1,
          perPage: this.pagination.perPage,
          mediaType: this.mediaType,
        }

        if (category) reqParams.category = category;
        if (search) reqParams.search = search;

        const medias = await api('medias', reqParams)

        if (medias && medias.result) {
          const result = medias.result;

          const pagination = this.pagination;
          pagination.currentPage = result.currentPage;
          pagination.totalPages = result.totalPages;
          pagination.rows = result.totalPages * this.pagination.perPage;

          this.pagination = pagination;
          this.videoData = result.medias;
          this.isEmptyPage = !result.medias.length;
        }
      } catch (e) {
        this.pagination = {
          ...this.pagination,
          currentPage: 1,
          totalPages: 1,
        };
        this.videoData = [];
        this.isEmptyPage = true;
      }
    },
    handleSelectedCategory(category) {
      this.search = ''
      this.fetchMediaList('', category)
    },
    getFilterData() {
      setTimeout(() => {
        this.popularVideoData = [
          {
            mediaTitle: "Most Watched",
            isActive: false,
          },
          {
            mediaTitle: "Lorem Ipsum Dolor Sit Amet",
            isActive: false,
          },
          {
            mediaTitle: "Lorem Ipsum Dolor Sit Amet",
            isActive: false,
          },
          {
            mediaTitle: "Lorem Ipsum Dolor Sit Amet",
            isActive: false,
          },
        ];
        this.otherVideoData = [
          {
            mediaTitle: "Archive",
            isActive: false,
          },
        ];
        this.isPopularVideoReady = true;
      }, 1500);
    },
  },
  async created() {
    this.getFilterData()
    this.fetchFeaturedMediaList()
    this.fetchMediaList();
    try {
      const result = await api("categories", {
        featured: true,
      });
    } catch (e) {
      console.error(e);
    }
  }
};
